<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="filteredProjectsList"
      item-key="id"
      show-expand
      :expanded.sync="expanded"
      :header-props="{ sortIcon: null }"
      :items-per-page="-1"
      single-expand
      hide-default-footer
    >
      <template v-slot:item="{ item, isExpanded, expand }">
        <tr @click="expand(!isExpanded)" style="cursor: pointer;">
          <td>
            <div class="project-title-container">
              <span class="project-title">{{ item.name }}</span>
              <v-chip class="font-weight-bold white vertical-middle elevation-2 ml-3">
                {{ item.workflowCount }}
              </v-chip>
            </div>
          </td>
          <td>
            <v-icon>{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </td>
        </tr>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-2" :key="item.id">
          <WorkflowExpandedTable
            @call-edit-form="handleForm"
            :projectData="item" />
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// libraries
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
// internal
import { customBreakpoint, timeUnits } from "@/utils/mixins";
import WorkflowExpandedTable from "@/components/Workflows/WorkflowExpandedTable.vue";

export default {
  name: "WorkflowNewTable",
  components: {
    WorkflowExpandedTable
  },
  props: {
    closeExpandedItems: {
      type: Number,
      default: false
    }
  },
  data() {
    return {
      expanded: [],
      headers: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: '', value: 'data-table-expand' },
      ],
    };
  },
  mixins: [customBreakpoint, timeUnits],
  watch: {
    closeExpandedItems() {
      if (this.closeExpandedItems)
      this.expanded = [];
    }
  },
  computed: {
    ...mapGetters("workflow", [
      "gWorkflowResponseTotalElements",
      "gWorkflowTablePage",
      "gWorkflowTableSize"
    ]),
    ...mapGetters("assignment", ["projectsList"]),
    filteredProjectsList() {
      return this.projectsList.filter(el => el.workflowCount > 0);
    }
  },
  methods: {
    ...mapActions("workflow", [
      "aSetWorkflowTablePage",
      "aSetWorkflowTableSize"
    ]),
    handleForm(item) {
      this.$emit("call-edit-form", item);
    }
  },
};
</script>

<style scoped lang="scss">
.group-header-row {
  background-color: #9af9ef70 !important;
  color: #003a35 !important;
}
.vertical-middle {
  vertical-align: middle;
}

::v-deep {
  tbody > tr {
    cursor: pointer;
  }
  .v-data-table.laptop .v-data-table__wrapper table {
    & tbody > tr > td {
      padding: 0 8px;
    }
    & .v-data-table-header tr > th {
      padding: 0 8px;
    }
  }
  .v-data-table.laptopSmaller .v-data-table__wrapper table {
    & tbody > tr > td {
      padding: 0 4px;
    }
    & .v-data-table-header tr > th {
      padding: 0 4px;
    }
  }
}

.project-title-container {
  display: flex;
  align-items: center
}

.project-title {
  display: inline-block;
  font-weight: 700 !important;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 18px !important;
}
</style>  